import Search from "../../../assets/icons/search.svg";
import { useServiceStore } from "../../../stores/admin/service";

const SearchBar = () => {
  const { searchTerm, setSearchTerm } = useServiceStore();

  return (
    <div className="relative w-full md:w-72">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <img
          src={Search}
          alt="search"
          className="w-5 h-5 text-gray-400"
        />
      </div>
      <input
        type="text"
        className="search-input w-full rounded-xl border border-gray-200 bg-white py-2 pl-10 pr-10 text-base font-medium text-gray-900 shadow-sm transition-all duration-200 placeholder-gray-500 hover:shadow-md focus:border-transparent focus:outline-none focus:ring-2 focus:ring-blue-500 focus:shadow-lg"
        placeholder="Rechercher ..."
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value);
        }}
      />
      {searchTerm && (
        <button
          onClick={() => setSearchTerm("")}
          className="absolute inset-y-0 right-0 pr-3 flex items-center"
        >
          <svg className="w-5 h-5 text-gray-400 hover:text-gray-600 transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default SearchBar;